import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { getCaptureLocationMap } from "../../api/captures/captureLocation";
import { listCaptures } from "../../api/captures/listCaptures";

interface FilterOptions {
  managementUnitId?: number;
  militaryMap?: string;
  search?: string;
}

export const useEntityCaptures = (entityIdStr?: string) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [filtersState, setFiltersState] = useState<FilterOptions>({});

  const setFilters = (newFilters: FilterOptions) => {
    setPage(0);
    setFiltersState(newFilters);
  };

  const entityId = Number(entityIdStr);

  const capturesQuery = useQuery({
    queryKey: [
      "entity",
      entityId,
      "captures",
      { page, rowsPerPage, ...filtersState },
    ],
    queryFn: () =>
      listCaptures(
        entityId,
        filtersState.managementUnitId,
        filtersState.search,
        filtersState.militaryMap,
        rowsPerPage,
        page * rowsPerPage,
      ),
    enabled: !!entityId,
    placeholderData: keepPreviousData,
  });

  const mapQuery = useQuery({
    queryKey: ["entity", entityId, "map", { ...filtersState }],
    queryFn: () =>
      getCaptureLocationMap(
        entityId,
        filtersState.managementUnitId,
        undefined,
        filtersState.militaryMap,
        filtersState.search,
      ),
    enabled: !!entityId,
    placeholderData: keepPreviousData,
  });

  return {
    page,
    rowsPerPage,
    filters: filtersState,
    setPage,
    setRowsPerPage,
    setFilters,
    capturesQuery,
    mapQuery,
  };
};
